import { PropsWithChildren } from 'react';

export const FooterFlexRow = ({ children }: PropsWithChildren) => {
  return <div className="flex flex-row lg:items-center">{children}</div>;
};
